import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "@shared/models/redux";
import {
  ReportType,
  ReportAvailabilityResponse,
  ReportAvailabilityRequest,
} from "@administrationReports/models/reportAvailability.models";
import { REPORT_CONFIG } from "@administrationReports/constants/reportConfig";
import { TimeRangeIDs } from "@documents/models/filter.models";

// Fetches data availability to determine best default filter
export const fetchReportAvailabilityThunk = createAsyncThunk<ReportAvailabilityResponse, ReportType, ThunkApiConfig>(
  "administrationReports/fetchReportAvailabilityThunk",
  async (reportType, { rejectWithValue, extra }) => {
    const config = REPORT_CONFIG[reportType];

    if (!config || !config.endpoint) {
      return rejectWithValue({
        hasData: false,
        filters: [
          {
            filterName: "dateRange",
            hasData: false,
            dataAvailableFrom: null,
            dataAvailableTo: null,
            recommendedTimeRange: TimeRangeIDs.LAST30,
          },
        ],
      });
    }

    try {
      if (config.service === "entitlements") {
        const response = await extra<ReportAvailabilityResponse>(config.endpoint, {
          method: "get",
        });

        return response.data;
      }

      const body: ReportAvailabilityRequest = { reportType };

      const response = await extra<ReportAvailabilityResponse, ReportAvailabilityRequest>(config.endpoint, {
        method: "post",
        body,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue({
        hasData: false,
        filters: [
          {
            filterName: "dateRange",
            hasData: false,
            dataAvailableFrom: null,
            dataAvailableTo: null,
            recommendedTimeRange: TimeRangeIDs.LAST30,
          },
        ],
      });
    }
  }
);
